export const TOASTIFY_OPTIONS = { hideProgressBar: true };

export const DEFAULT_VALUES = {
  description: '',
  fileName: '',
  file: undefined,
};
